import axios from 'axios'
import qs from "qs";

// actions
export const actions = {
    async destroy(_ctx, payload) {
        try {
            await axios.delete('/api/uji-kompetensi/' + payload)
        } catch (error) {
            return []
        }
    },
    async update(_ctx, payload) {
        try {
            let data = await axios.patch('/api/uji-kompetensi/' + payload.id, qs.stringify(payload.data))
            return data
        } catch (error) {
            return []
        }
    },
    async store(_ctx, payload) {
        try {
            let data = await axios.post('/api/uji-kompetensi', qs.stringify(payload))
            return data
        } catch (error) {
            return []
        }
    },
    async index(_ctx, payload) {
        const { data } = await axios.get('/api/uji-kompetensi?page=' + payload.page + '&search=' + payload.data.nip)
        return data
    },
    async by_pegawai(_ctx, payload) {
        const { data } = await axios.get('/api/uji-kompetensi/by-pegawai?nip=' + payload.nip)
        return data
    }
}
